import * as _ from 'lodash'
import { ElementProperties, Variable, Div, H2, Header } from 'alkali'
import AnnotatableText from './AnnotatableText'
import { NCTIdAnnotator } from './model/Annotators'
import StudySummaryModel from './model/StudySummaryModel'

interface ReadOnlyAbstractOpts extends ElementProperties<ReadOnlyAbstract> {
	summary: StudySummaryModel
}

/**
 * Read-only view of the study abstract, with the default read-only/non-interactive AnnotableText
 */
export default class ReadOnlyAbstract extends Div('.view-abstract') {
	created(props: ReadOnlyAbstractOpts) {
		const { abstractSource, abstract } = props.summary
		props.content = [
			Header([
				H2(abstractSource.property('Title'))
			]),
			new AnnotatableText('.study-abstract.annotations', {
				text: abstract.property('text'),
				annotations: abstract.to(abs => {
					const nctids = new NCTIdAnnotator().annotate(abs.annotations, abs.sentences, null).annotations
					return _.sortBy(nctids.concat(abs.annotations).filter(a => a.visual != false), a => a.start)
				})
			})
		]
	}
}